// Mirror of PIRO.API.v3/Entities/SignalRNotificationTypes.cs — keep in sync.
export const signalRNotificationTypes = {
  General: 'General',
  TerminalStatus: 'TerminalStatus',
  OpenOrder: 'OpenOrder',
}
